function appConfigAuth($httpProvider) {
    'ngInject';

    // Patch related with: https://github.com/oauthjs/angular-oauth2/issues/32
    function authInterceptor($q, $rootScope) {
        'ngInject';
        return {
            responseError: function(rejection) {
                if (401 === rejection.status && rejection.data && 'invalid_grant' === rejection.data.error) {
                    $rootScope.$emit('oauth:error', rejection);
                }
                return $q.reject(rejection);
            }
        };
    }
    $httpProvider.interceptors.push(authInterceptor);
}

export default appConfigAuth;


// WEBPACK FOOTER //
// ./client/app/app.config.auth.js